import React, { useEffect, useRef, useState } from 'react';
import classes from "./EditProfile.module.css";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import SmallLoader from '../component/SmallLoader';
import { FaTrash, FaUpload } from 'react-icons/fa6';
import Container from '../component/Container';
import { getProfileApi, editProfileApi } from '../http/http';
import { useTranslation } from 'react-i18next';

const EditProfile = () => {
    const [profile, setProfile] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    const { userDetails } = useSelector((state) => state.persisted.userSlice);

    const {t}=useTranslation();

    const [state, setState] = useState({
        name: "",
        image: "",
    });

    const [pickedImage, setPickedImage] = useState();
    const imageInput = useRef();

    function handlePickClick() {
        imageInput.current.click();
    }

    function handleImageChange(event) {
        const file = event.target.files[0];

        if (!file) {
            setPickedImage(null);
            return;
        }

        const fileReader = new FileReader();

        fileReader.onload = () => {
            setPickedImage(fileReader.result);
            // setState(prevState => ({ ...prevState, image: fileReader.result }));
        };

        fileReader.readAsDataURL(file);
        setState(prevState => ({ ...prevState, image: file }));
    }

    const fetchUserProfile = async () => {
        try {
            setLoading(true);
            const response = await getProfileApi(userDetails?.token);
            setProfile(response?.data);
            setState((prevValue) => ({ ...prevValue, name: response?.data?.name || "Guest" }));
            setLoading(false);
        } catch (error) {
            toast.error(error?.response?.data?.error?.error || error?.response?.error?.error || error?.response?.error || "Something Went Wrong!");
        }
    }


    useEffect(() => {
        if (userDetails?.token) {
            fetchUserProfile();
        }
    }, [userDetails]);

    const submitHandler = async (e) => {
        try {
            e.preventDefault();
            setSaveLoading(true);

            const formData = new FormData();
            formData.append("name", state?.name);
            if (state?.image) {
                formData.append("file", state?.image ?? null);
            }

            const result = await editProfileApi(formData, userDetails?.token);
            setSaveLoading(false);
            setPickedImage(null);
            toast.success("Profile update has been completed successfully.")
            fetchUserProfile();
        } catch (error) {
            toast.error("Something Went Wrong!");
        }
    }


    return (
        <Layout>
            <SubLayout>
                <Header active={4} />

                <Container>
                    {loading ? <SmallLoader /> : (
                        <form onSubmit={submitHandler} className={classes.form} enctype="multipart/form-data">
                            <div className={classes.edit_avatar_section}>
                                <div className={classes.avatar_image_container}>
                                    <img src={profile?.image || "/assets/images/avatar.png"} alt="profile pic" className={classes.avatar_image} />
                                    <span className={classes.badge}>
                                        <FaTrash className={classes.trash_icon} />
                                    </span>
                                </div>

                                <div>
                                    <input
                                        className={classes.input}
                                        type="file"
                                        id="image"
                                        accept="image/png, image/jpeg"
                                        name="file"
                                        ref={imageInput}
                                        onChange={handleImageChange}
                                    />
                                    <button
                                        className={classes.button}
                                        type="button"
                                        onClick={handlePickClick}
                                    >
                                        <FaUpload className={classes.upload_icon} />
                                        {t("120")}
                                    </button>
                                </div>

                            </div>

                            {pickedImage && (
                                <div className={classes.selected_image_container}>
                                    <img
                                        src={pickedImage}
                                        alt="The image selected by the user."
                                        className={classes.selected_image}
                                    />
                                </div>
                            )}

                            <div className={classes.user_details_container}>
                                <p className={classes.user_name}>{t("121")}</p>
                                <input type='text' className={classes.user_name_input} name='name' placeholder={t("122")} value={state.name} onChange={(event) => setState({ ...state, name: event.target.value })} />
                                <button className={classes.save_changes_btn} type='submit' disabled={saveLoading} >
                                    {saveLoading ? t("123") : t("124")}
                                </button>
                            </div>
                        </form>
                    )}
                </Container>
            </SubLayout>
        </Layout>
    )
}

export default EditProfile